import PatientProfileCard from './PatientProfileCard';
export default PatientProfileCard;
